"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _superagent = _interopRequireDefault(require("superagent"));
var _superagentLegacyiesupport = _interopRequireDefault(require("superagent-legacyiesupport"));
var _dateHelper = _interopRequireDefault(require("static-site-generator-shared/plugins/lib/dateHelper"));
var _tracker = _interopRequireDefault(require("static-site-generator-shared/plugins/lib/tracker"));
var _engineHelper = _interopRequireDefault(require("../engineHelper"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class FlightDropdown extends _react.default.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      chosenFlight: false,
      interacted: false,
      searching: false,
      flightStore: {}
    };
    this.interactedWith = this.interactedWith.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.showResults = this.showResults.bind(this);
    this.filterFlight = this.filterFlight.bind(this);
    this.shouldMakeSearch = this.shouldMakeSearch.bind(this);
    this.storeNextDaysResults = this.storeNextDaysResults.bind(this);
  }
  componentDidMount() {
    this._isMounted = true;
    this.shouldMakeSearch();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.chosenFlight !== prevState.chosenFlight && this.props.onChange) this.props.onChange(this.state.chosenFlight);
    if (_engineHelper.default.checkUpdated(prevProps.departure, this.props.departure)) this.shouldMakeSearch();
    if (_engineHelper.default.checkUpdated(prevProps.startTime, this.props.startTime)) this.shouldMakeSearch();
    if (_engineHelper.default.checkUpdated(prevProps.departureTime, this.props.departureTime)) this.shouldMakeSearch();
    if (_engineHelper.default.checkUpdated(prevProps.departureTimeMax, this.props.departureTimeMax)) this.shouldMakeSearch();
    if (_engineHelper.default.checkUpdated(prevProps.location, this.props.location)) this.shouldMakeSearch();
    if (_engineHelper.default.checkUpdated(prevProps.flightEndpoint, this.props.flightEndpoint)) this.shouldMakeSearch();
  }
  track(name, value = '1') {
    const {
      trackingPrefix
    } = this.props;
    try {
      _tracker.default.track(trackingPrefix + name, value);
    } catch (e) {
      // console.log('Didn\'t Track')
    }
  }
  resetFlight(searching = false) {
    const {
      cookieName
    } = this.props;
    _engineHelper.default.engineCookies(cookieName, '');
    this.setState({
      chosenFlight: false,
      searching
    });
  }
  filterFlight(flightNumber) {
    const flights = this.checkStore();
    let flightIndex = 0;
    let chosenFlight = flights.filter((f, key) => {
      if (f.flight.code === flightNumber) flightIndex = key;
      return f.flight.code === flightNumber;
    });
    chosenFlight = chosenFlight.length ? chosenFlight[0] : false;
    return {
      chosenFlight,
      flightIndex
    };
  }
  handleSelectChange(e) {
    const {
      cookieName
    } = this.props;
    let {
      value
    } = e.target;
    let {
      chosenFlight,
      flightIndex
    } = this.filterFlight(value);
    if (['flight_unknown', 'flight_inline_donthaveit', 'flight_not_listed', 'flight_incorrect'].indexOf(value) !== -1) {
      chosenFlight = {
        flight: {
          code: value
        }
      };
    }
    _engineHelper.default.engineCookies(cookieName, value);
    this.setState({
      chosenFlight,
      interacted: true
    });
    this.trackChosenFlight(value, flightIndex);
  }
  shouldMakeSearch() {
    if (!this.props.location || !this.props.departure) return;
    this.lookupFlights();
  }
  correctDate(departure) {
    return typeof departure === 'object' ? departure : new Date(departure);
  }
  makeRequestURL(nextDay = false) {
    const {
      flightEndpoint,
      location
    } = this.props;
    let departDate = this.correctDate(this.props.departure);
    if (nextDay) departDate = _dateHelper.default.alterDateByNumberOfDays(departDate, '+1');
    departDate = _dateHelper.default.nativeDateToIso(departDate);
    const url = [flightEndpoint + 'searchDayFlights?query=', 'location=' + location, 'departDate=' + departDate, 'noCodeShares=1'];
    this.track('searching', JSON.stringify({
      location,
      departDate
    }));
    return url.join('&');
  }
  lookupFlights(nextDay = false, callback = this.showResults) {
    if (!nextDay && this.checkStore()) return this.showResults();
    if (nextDay && this.checkStore(nextDay)) return;
    try {
      _superagent.default.get(this.makeRequestURL(nextDay)).use(_superagentLegacyiesupport.default).end(callback);
    } catch (e) {
      // console.log('Fligh dropdown failed to search', e)
    }
  }
  showResults(err, res) {
    if (!this._isMounted) return;
    if (err || !(res && res.body)) return this.resetFlight();
    if (res && res.body) this.checkOrUpdateStore(res.body);
    this.lookupFlights(true, this.storeNextDaysResults);
  }
  storeNextDaysResults(err, res) {
    if (!this._isMounted) return;
    if (err || !(res && res.body)) return;
    this.checkOrUpdateStore(res.body, true);
  }
  checkStore(nextDay = false) {
    const {
      flightStore
    } = this.state;
    const {
      location,
      startTime,
      departureTime,
      departure
    } = this.props;
    if (!nextDay) nextDay = parseInt(departureTime) < parseInt(startTime);
    const key = this.getKeyFromDate(departure, nextDay);
    if (!flightStore || !key || !location) return false;
    if (!flightStore.hasOwnProperty(location + key)) return false;
    if (!flightStore[location + key].length) return false;
    return flightStore[location + key] || false;
  }
  getKeyFromDate(departure, nextDay = false) {
    departure = this.correctDate(departure);
    if (nextDay) departure = _dateHelper.default.alterDateByNumberOfDays(departure, '+1');
    if (!departure) return false;
    const departureDate = _dateHelper.default.nativeDateToIso(departure);
    return departureDate ? departureDate.replace(/-/g, '') : false;
  }
  checkOrUpdateStore(data, nextDay = false) {
    const flightStore = JSON.parse(JSON.stringify(this.state.flightStore));
    const {
      location
    } = this.props;
    const dateKey = this.getKeyFromDate(data[0].departure.date);
    if (!dateKey || this.checkStore(dateKey)) return data;
    flightStore[location + dateKey] = data;
    this.setState({
      flightStore,
      searching: false
    });
    return data;
  }
  trackChosenFlight(flightNumber, flightIndex) {
    const flights = this.checkStore();
    if (!flightNumber) this.track('cant_find_flight');else if (flightNumber === 'flight_not_listed' || flightNumber === 'flight_or_incorrect' || flightNumber === 'flight_unknown') {
      this.track(flightNumber);
    } else {
      this.track('total_and_chosen_position', flights.length + ' - ' + flightIndex);
      this.track('chosen', flightNumber);
    }
  }
  interactedWith() {
    const {
      flightFieldInteraction
    } = this.props;
    if (this.state.interacted) return;
    this.track('interacted');
    if (typeof flightFieldInteraction === 'function') flightFieldInteraction();
    this.setState({
      interacted: true
    });
  }
  haveFlights() {
    const {
      chosenFlight
    } = this.state;
    const flights = this.checkStore();
    return flights.length > 0 && !chosenFlight;
  }
  shouldShowOption(flight) {
    const {
      departureTime,
      departureTimeMax
    } = this.props;
    if (!flight || !flight.departure || !flight.departure.time) return false;
    const flightTime = flight.departure.time.replace(/:/g, '');
    return flightTime >= departureTime && flightTime <= +departureTime + departureTimeMax;
  }
  createDropdownOptions(flights) {
    let {
      terminal
    } = this.props;
    if (!flights.length) return null;
    let terminals = {};
    flights.filter(i => i && i.departure && this.shouldShowOption(i)).map((flight, key) => {
      if (!flight || !flight.departure) return;
      const flightTerminal = terminal || !flight.departure.terminal ? '' : ` Terminal ${flight.departure.terminal}`;
      const cityName = flight.arrival.city === 'London' ? flight.arrival.airport : flight.arrival.city;
      const airportName = flight.arrival.airport.replace(' International', '');
      const flightText = `${flight.departure.time} ${cityName} (${flight.arrival.airport_iata} ${airportName}${flightTerminal})`;
      const element = /*#__PURE__*/_react.default.createElement("option", {
        key: key,
        value: flight.flight.code
      }, flightText);
      if (!terminals[terminal ? flight.departure.terminal : '']) terminals[terminal && flight.departure.terminal ? flight.departure.terminal : ''] = [];
      terminals[terminal && flight.departure.terminal ? flight.departure.terminal : ''].push(element);
    });
    if (!terminal) return terminals[''];
    terminal = terminal + '';
    const output = [];
    const currentTerminal = terminals[terminal];
    delete terminals[terminal];
    const element = /*#__PURE__*/_react.default.createElement("optgroup", {
      key: terminal,
      label: `Terminal ${terminal}`
    }, currentTerminal);
    output.push(element);
    Object.keys(terminals).map(key => {
      const term = terminals[key];
      if (!key) key = 'Unknown';
      const element = /*#__PURE__*/_react.default.createElement("optgroup", {
        key: key,
        label: `Terminal ${key}`
      }, term);
      output.push(element);
      return key;
    });
    return output;
  }
  render() {
    const {
      name,
      placeHolder,
      id,
      flightSearchInputRef
    } = this.props;
    let {
      chosenFlight,
      searching
    } = this.state;
    const flights = this.checkStore() || [];
    const filteredFlights = flights.filter(i => i && i.departure && this.shouldShowOption(i));
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "hideLabelSplitTest",
      id: "flightSearch"
    }, /*#__PURE__*/_react.default.createElement("select", {
      onClick: this.interactedWith,
      onChange: this.handleSelectChange,
      id: id,
      value: chosenFlight ? chosenFlight.flight.code : '',
      name: name,
      ref: flightSearchInputRef,
      className: "form-control"
    }, filteredFlights.length > 0 && /*#__PURE__*/_react.default.createElement("option", {
      value: "flight_not_chosen"
    }, `${placeHolder} (${filteredFlights.length})`), !filteredFlights.length && searching && /*#__PURE__*/_react.default.createElement("option", {
      value: "TBC"
    }, "Searching"), !filteredFlights.length && !searching && /*#__PURE__*/_react.default.createElement("option", {
      value: "TBC"
    }, "No flights found"), filteredFlights.length > 0 && this.createDropdownOptions(filteredFlights), filteredFlights.length > 0 && /*#__PURE__*/_react.default.createElement("option", {
      value: "flight_unknown"
    }, `Don't know my flight`), filteredFlights.length > 0 && /*#__PURE__*/_react.default.createElement("option", {
      value: "flight_inline_donthaveit"
    }, `Don’t have it to hand`), filteredFlights.length > 0 && /*#__PURE__*/_react.default.createElement("option", {
      value: "flight_not_listed"
    }, "Flight not listed"), filteredFlights.length > 0 && /*#__PURE__*/_react.default.createElement("option", {
      value: "flight_incorrect"
    }, "Flight incorrect")));
  }
}
FlightDropdown.propTypes = {
  name: _propTypes.string,
  placeHolder: _propTypes.string,
  cookieName: _propTypes.string,
  departure: (0, _propTypes.oneOfType)([_propTypes.number, (0, _propTypes.instanceOf)(Date)]),
  departureTime: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  departureTimeMax: _propTypes.number,
  startTime: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  location: _propTypes.string,
  trackingPrefix: _propTypes.string,
  terminal: _propTypes.string,
  onChange: _propTypes.func,
  id: _propTypes.string,
  flightFieldInteraction: _propTypes.func,
  flightEndpoint: _propTypes.string
};
FlightDropdown.defaultProps = {
  placeHolder: 'Choose flight',
  name: 'flight_number',
  cookieName: 'FlightNumber',
  departureTimeMax: 100,
  trackingPrefix: 'flight_',
  flightEndpoint: ''
};
var _default = exports.default = FlightDropdown;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/components/flight-lookup/flight-dropdown.js
// module id = 746
// module chunks = 119